import { render } from "./ViewProfile.vue?vue&type=template&id=5caab9c5&scoped=true"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"

import "@/css/views/view-profile.css?vue&type=style&index=0&id=5caab9c5&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caab9c5"]])

export default __exports__